export const SET_AUTH = 'SET_AUTH'
export const REMOVE_AUTH = 'REMOVE_AUTH'
export const SET_USER = 'SET_USER'
export const SET_TOKEN = 'SET_TOKEN'
